export default __webpack_public_path__ + "static/13.Nurture Pods-500e6781f2f00827b06492f97d919694.png";